import { render, staticRenderFns } from "./ConfigAlertHttpPost2.vue?vue&type=template&id=5722dc31&"
import script from "./ConfigAlertHttpPost2.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertHttpPost2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports